"use client";

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function AdvancedFilterModal({ children }: { children: React.ReactNode }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Advanced Transaction Filter</DialogTitle>
          <DialogDescription>
            Pinpoint exactly the transactions you are looking for.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Start Date</Label>
              <Input type="date" />
            </div>
            <div className="space-y-2">
              <Label>End Date</Label>
              <Input type="date" />
            </div>
          </div>
          
          <div className="space-y-2">
            <Label>Transaction Status</Label>
            <div className="flex gap-2 flex-wrap">
              {['Successful', 'Pending', 'Failed', 'Refunded'].map(status => (
                <BadgeSelectable key={status} label={status} />
              ))}
            </div>
          </div>

          <div className="space-y-2">
            <Label>Payment Channel</Label>
            <div className="flex gap-2 flex-wrap">
              {['Card', 'Transfer', 'USSD', 'Payout'].map(channel => (
                <BadgeSelectable key={channel} label={channel} />
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Min Amount (₦)</Label>
              <Input type="number" placeholder="0.00" />
            </div>
            <div className="space-y-2">
              <Label>Max Amount (₦)</Label>
              <Input type="number" placeholder="Any" />
            </div>
          </div>

          <div className="flex justify-between items-center mt-4">
            <Button variant="ghost" className="text-muted-foreground">Reset Filters</Button>
            <Button>Apply Filters</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

function BadgeSelectable({ label }: { label: string }) {
  return (
    <div className="px-3 py-1 rounded-full border text-xs font-medium cursor-pointer hover:bg-primary/10 hover:border-primary/30 transition-colors">
      {label}
    </div>
  );
}
